<template>
  <div class="forget-pwd-container">
    <login-index>
      <!-- 重置密码start -->
      <div v-if="retrieveStep === 2" class="reset-pwd-view">
        <el-form
          ref="resetPwdForm"
          :model="resetPwdForm"
          :rules="pwdRules"
          class="login-form"
          hide-required-asterisk
          label-position="top"
          size="small"
          status-icon
          @keyup.enter.native="resetPasswordHandle"
        >
          <div class="login-form-title">重置密码</div>
          <el-form-item class="mb-40 login-form-account" prop="password">
            <span class="login-form-text">新密码</span>
            <el-input
              class="login-form-input"
              v-model="resetPwdForm.password"
              autocomplete="off"
              placeholder="请输入密码"
              show-password
              clearable
            >
            </el-input>
          </el-form-item>

          <el-form-item prop="rePassword" :class="{ 'mb-40': !showPwdTips }">
            <span class="login-form-text">确认密码</span>
            <div style="position: relative">
              <el-input
                class="login-form-input"
                ref="password"
                @keyup.enter.native="resetPasswordHandle"
                v-model="resetPwdForm.rePassword"
                autocomplete="off"
                placeholder="请再次输入密码"
                show-password
                clearable
              >
              </el-input>
            </div>
            <span v-if="showPwdTips" class="login-form-tips mb-20">{{ constants.passwordRegDesc }}</span>
          </el-form-item>

          <el-button
            :loading="loading"
            class="login-form-btn"
            type="primary"
            size="mini"
            v-re-click
            @click.native.prevent="resetPasswordHandle"
            >提交</el-button
          >
        </el-form>
      </div>
      <!-- 找回密码start -->
      <div v-else class="pwd-container">
        <el-form
          ref="emailForm"
          :model="retrieveAccountForm"
          :rules="emailRules"
          class="login-form"
          hide-required-asterisk
          label-position="top"
          size="small"
          status-icon
          @keyup.enter.native="sendEmailValidateHandle"
        >
          <div class="login-form-title">找回密码</div>
          <el-form-item class="mb-40 login-form-account" prop="email">
            <span class="login-form-text">邮箱找回</span>
            <el-input
              class="login-form-input mt-30"
              v-model="retrieveAccountForm.email"
              placeholder="请输入邮箱"
              type="text"
              tabindex="1"
              auto-complete="on"
              clearable
            >
            </el-input>
            <span v-if="retrieveStep === 3" class="login-form-tips fs14">
              我们已向你的邮箱中发送了重置密码的邮件，请查看并点击邮件中的链接。
              没有收到邮件？请检查您的垃圾邮件或者重新发送
            </span>
          </el-form-item>

          <el-button
            :disabled="findPwdBtnLoading"
            class="login-form-btn mt-40"
            type="primary"
            size="mini"
            v-re-click
            @click.native.prevent="sendEmailValidateHandle"
            >{{ findPwdBtnText }}</el-button
          >
        </el-form>
      </div>
    </login-index>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import LoginIndex from './components/LoginIndex.vue'
import { encryptPassword } from '@/utils/encrypt.js'

export default {
  name: 'RetrievePwd',
  components: { LoginIndex },
  data() {
    const validateRePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
        this.showPwdTips = false
      } else if (value !== this.resetPwdForm.password) {
        callback(new Error('两次输入密码不一致!'))
        this.showPwdTips = false
      } else {
        callback()
      }
    }
    return {
      showPwdTips: true,
      retrieveStep: 1,
      retrieveType: 'email',
      emailValidateCodeBtn: false,
      emailValidateCodeBtnText: '发送验证码',
      findPwdBtnLoading: false,
      findPwdBtnText: '找回密码',
      emailSendSuccess: true,
      retrieveAccountForm: {
        phoneNumber: '',
        email: '',
        password: ''
      },
      resetAccount: '',
      resetPwdForm: {
        code: '',
        password: '',
        rePassword: ''
      },
      constants,
      phoneRules: {
        phoneNumber: [
          { required: true, trigger: 'blur', message: '请输入手机号' },
          {
            pattern: /^(?:0|86|\+86)?1[3456789]\d{9}$/,
            message: '请输入正确的手机号'
          }
        ],
        code: { required: true, trigger: 'blur', message: '请输入验证码' }
      },
      emailRules: {
        email: [
          { required: true, trigger: 'blur', message: '请输入邮箱' },
          {
            pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
            message: '请输入正确的邮箱'
          }
        ]
      },
      pwdRules: {
        password: [
          { required: true, trigger: 'blur', message: '请输入新密码' },
          {
            pattern: constants.passwordReg,
            message: constants.passwordRegDesc
          }
        ],
        rePassword: [{ required: true, trigger: 'blur', validator: validateRePass }]
      }
    }
  },
  created() {
    const code = this.$route.query.code
    if (code) {
      this.resetAccount = this.$route.query.email
      this.resetPwdForm.code = code
      this.retrieveStep = 2
    }
  },
  methods: {
    sendPhoneValidateCodeHandle() {
      this.$refs['phoneForm'].validateField('phoneNumber', (err) => {
        if (!err) {
          this.sendPhoneValidateCode()
        }
      })
    },
    sendPhoneValidateCode() {
      const phoneNumber = this.retrieveAccountForm.phoneNumber
      this.$refs['phoneForm'].validateField('phoneNumber', (err) => {
        if (!err) {
          this.emailValidateCodeBtn = true
          this.$api
            .request({
              url: '/retrieve/password/phone/code',
              method: 'get',
              params: { phoneNumber: phoneNumber }
            })
            .then(() => {
              this.msgSuccess('验证码发送成功，5分钟内有效')
              this.emailValidateCodeBtn = true
              let count = 60
              const timer = setInterval(() => {
                count--
                this.findPwdBtnText = count + 's后重新发送'
                if (count == 0) {
                  this.findPwdBtnText = '发送验证码'
                  this.emailValidateCodeBtn = false
                  clearInterval(timer)
                }
              }, 1000)
            })
        }
      })
    },
    phoneRetrievePassWordHandle() {
      this.$refs['phoneForm'].validate((valid) => {
        if (valid) {
          this.$api.post('/retrieve/password/check/phone-code', this.retrieveAccountForm).then((res) => {
            if (res.data) {
              this.msgSuccess('验证成功')
              this.resetPwdForm.code = res.data
              this.resetAccount = this.retrieveAccountForm.phoneNumber
              this.retrieveStep = 2
            }
          })
        }
      })
    },
    resetPasswordHandle() {
      this.$refs['resetPwdForm'].validate((valid) => {
        const { resetPwdForm } = this
        const params = {
          ...resetPwdForm,
          password: encryptPassword(resetPwdForm.password),
          rePassword: encryptPassword(resetPwdForm.rePassword),
        }
        if (valid) {
          this.$api.post('/retrieve/password/reset', params).then((res) => {
            if (res.data) {
              this.msgSuccess('密码重置成功，快去登录吧')
              setTimeout(() => {
                this.$router.push({ path: '/login' })
              }, 2000)
            }
          })
        }
      })
    },
    sendEmailValidateHandle() {
      this.$refs['emailForm'].validateField('email', (err) => {
        if (!err) {
          this.sendEmailValidate()
        }
      })
    },
    sendEmailValidate() {
      this.$refs['emailForm'].validate((valid) => {
        if (valid && !this.findPwdBtnLoading) {
          this.$api
            .request({
              url: '/retrieve/password/email',
              method: 'get',
              params: { email: this.retrieveAccountForm.email }
            })
            .then(() => {
              this.retrieveStep = 3
              this.findPwdBtnLoading = true
              let count = 60
              const timer = setInterval(() => {
                count--
                this.findPwdBtnText = count + 's后重新发送'
                if (count == 0) {
                  this.retrieveStep = 1
                  this.findPwdBtnText = '找回密码'
                  this.findPwdBtnLoading = false
                  clearInterval(timer)
                }
              }, 1000)
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/mixin.scss';
@import '@/assets/styles/login.scss';
.pwd-container {
  .login-form-text {
    font-size: 22px;
  }
}

.login-form-tips {
  position: relative;
  line-height: normal;
  display: inline-block;
  margin-top: 5px;
  color: #545454;
}

.msg-view {
  @include position-center(xy);
  text-align: center;
  color: #929292;
  width: 30%;
}
</style>
